import {TranslationsService} from "@inter-ikea-kompis/services"
import {ITranslations} from "@inter-ikea-kompis/types"
import {getLocale, getLocalizationEndpoints} from "../Utils/LocaleHelper"

export default class Localization {
  public getLocalization(): Promise<ITranslations> {
    const localizationService = new TranslationsService({
      locale: getLocale() ? getLocale() : "en-SE",
      translationPrefixApplication: "DEKIS",
      translationEndpoints: getLocalizationEndpoints(),
    })
    return localizationService.getTranslations()
  }
}
